import { useEffect } from "react";

// Adds `in-view` class to any element with class `reveal` when it scrolls into view.
export default function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // Runs once on mount to observe elements present at first render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
